<template>
  <vs-popup id="popupApprovalProcess" class="no-drag" title="결재선 지정" :active.sync="showPopupSync">
    <vs-row class="mb-6">
      <vs-col class="">
        <h5 class="mb-4"><i class="dot"></i>저장된 결재선</h5>
        <vs-row class="border" style="overflow-x: auto">
          <ul class="table table-no-2" style="min-width: 700px">
            <li>
              <span>No.</span>
              <span>이름</span>
              <span>결재경로</span>
            </li>
            <li
              class="tbody"
              v-for="(line, index) in lineList"
              :key="index"
              @click="
                () => {
                  lineClickItem(line.line_elements);
                }
              "
            >
              <span>{{ index + 1 }}</span>
              <span>{{ line.name }}</span>
              <span style="display: flex; flex-flow: wrap">
                <p v-for="(member, mIdx) in getLineElements(line.line_elements)" :key="mIdx"><span class="mx-2" v-if="mIdx > 0">→</span>{{ member.element_user ? member.element_user.name : "(이름없음)" }}</p>
                <vs-spacer></vs-spacer>
                <a href="javascript:;" style="width: 30px" @click.stop @click="() => removeLine(line.id)">삭제</a>
              </span>
            </li>
            <li class="tbody" style="grid-template-columns: 1fr">
              <div class="vs-con-table">
                <div class="con-pagination-table vs-table--pagination">
                  <k-pagination :total="page.lastPage" v-model="page.current" @change="handleChangePage" />
                </div>
              </div>
            </li>
            <li class="tbody">
              <span>
                <vs-button class="mr-4 small" color="secondary" @click="handleSave">저장</vs-button>
              </span>
              <span><ml-input v-model="lineTitle" /></span>
              <span style="display: flex; flex-flow: wrap">
                <p v-for="(member, mIdx) in getLineElements(getSelectElements)" :key="mIdx"><span class="mx-2" style="font-size: 0.85rem" v-if="mIdx > 0">→</span>{{ member.element_user ? member.element_user.name : "(이름없음)" }}</p>
                <vs-spacer></vs-spacer>
                <a v-if="getLineElements(getSelectElements).length > 0" href="javascript:;" style="width: 30px" @click.stop @click="initLine">리셋</a>
              </span>
            </li>
          </ul>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row style="overflow-x: auto">
      <vs-col style="min-width: 450px">
        <vs-col v-if="hasVirtualCompany" class="w-5/12 pr-4">
          <ml-input class="w-full mb-4" icon-pack="feather" icon="icon-search" icon-after="true" v-model="companyKeyword" />
          <div class="member-list">
            <div class="member-list-container">
              <company-tree-view ref="companyTreeView" :search-keyword="companyKeyword" default-code="DKS50106483" @node-selected="handleCompanySelected" />
            </div>
          </div>
        </vs-col>
        <vs-col class="pr-4" :class="[hasVirtualCompany ? 'w-3/12' : 'w-1/2']">
          <!-- 조직도-->
          <vs-row class="mb-4">
            <vs-col class="w-full" style="display: grid; grid-template-columns: 100px 1fr; align-items: center; column-gap: 0.75rem">
              <vs-select autocomplete style="width: 100px" v-model="searchType" @change="handleSearch">
                <vs-select-item text="전체" value="" />
                <vs-select-item text="이름" value="이름" />
                <vs-select-item text="부서" value="부서" />
              </vs-select>
              <ml-input class="w-full shadow" icon-pack="feather" icon="icon-search" icon-after="true" v-model="keyword" @keyup="handleSearch" />
            </vs-col>
          </vs-row>
          <vs-row class="member-list">
            <div ref="memberListContainer" class="member-list-container">
              <vs-col v-if="loadingMembers" class="w-full text-center" vs-type="flex" vs-align="center">
                <div class="w-full flex-col items-center justify-center mt-10">
                  <div><feather-icon icon="LoaderIcon" class="mr-2 rotate-icon" /></div>
                  <div style="font-size: 14px; color: #666">불러오는 중 입니다.</div>
                </div>
              </vs-col>
              <vs-col v-else-if="memberList.length === 0" class="w-full text-center" vs-type="flex" vs-align="center">
                <div class="w-full flex-col items-center justify-center mt-10">
                  <div><feather-icon icon="SearchIcon" class="mr-2" /></div>
                  <div style="font-size: 14px; color: #666">검색 결과가 없습니다.</div>
                </div>
              </vs-col>
              <draggable v-else class="w-full" :list="memberList" group="people">
                <vs-col class="w-full" vs-type="flex" vs-align="center" v-for="(member, index) in memberList" :key="index">
                  <div class="list-item sm:w-full w-full" :class="selectMember === member ? 'active' : ''" @click="selectMember = member">
                    <vs-list-item classs="active" :title="getMemberTitle(member)" :subtitle="member.department || member.company_name">
                      <vs-avatar slot="avatar" />
                    </vs-list-item>
                  </div>
                </vs-col>
              </draggable>
            </div>
          </vs-row>
        </vs-col>
        <vs-col :class="[hasVirtualCompany ? 'w-4/12' : 'w-1/2']">
          <!-- 결재 -->
          <vs-row class="right-body mb-4">
            <vs-col class="btn-list">
              <vs-button
                class="addbtn p-0 mb-2"
                type="border"
                @click="
                  () => {
                    removeMember('approval');
                  }
                "
                :disabled="isDisabledApprovalRemoveButton"
                >&lt;</vs-button
              >
              <vs-button
                class="addbtn p-0"
                type="border"
                @click="
                  () => {
                    addMember('approval');
                  }
                "
                :disabled="isDisabledApprovalAddButton"
                >&gt;</vs-button
              >
            </vs-col>
            <vs-col class="pl-4">
              <vs-row>
                <vs-col class="mb-2">
                  <h5><i class="dot"></i>결재</h5>
                </vs-col>
              </vs-row>
              <vs-row style="border: 1px solid #dfdfdf; border-radius: 4px; background-color: #f3f3f3">
                <ul class="table border-bottom table-title-1">
                  <li>
                    <span>결재</span>
                    <span>성명(부서)</span>
                  </li>
                </ul>

                <ul id="approval" class="table table-title-1">
                  <draggable class="w-full" :list="approvalLine" group="people" draggable=".item">
                    <li v-for="(member, index) in reversedApprovalLine" :key="index" class="tbody" :class="[selectMember === member ? 'active' : '', member.move ? 'item' : 'cursor-default']" @click="onClickApprovalItem(member)">
                      <span>결재{{ reversedApprovalLine.length - index }}</span>
                      <span>{{ member.user_name }}{{ member.rank ? ` ${member.rank}` : "" }}{{ member.department ? `(${member.department})` : "" }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-row>
            </vs-col>
          </vs-row>

          <!-- 결재부서 (게시판 옵션 useDocumentCompany: false 면 표시하지 않음) -->
          <vs-row v-if="useDocumentCompany" class="right-body mb-4">
            <vs-col class="btn-list">
              <vs-button class="addbtn p-0 mb-2" type="border" @click="removeDocumentCompany" :disabled="isDisabledDocumentCompanyRemoveButton">&lt;</vs-button>
              <vs-button class="addbtn p-0" type="border" @click="addDocumentCompany" :disabled="isDisabledDocumentCompanyAddButton">&gt;</vs-button>
            </vs-col>
            <template v-if="localDocumentCompany">
              <vs-col class="pl-4">
                <vs-row>
                  <vs-col class="mb-2">
                    <h5><i class="dot"></i>처리부서 {{ localDocumentCompany && localDocumentCompany.label ? `(${localDocumentCompany.label})` : "" }}</h5>
                  </vs-col>
                </vs-row>
                <vs-row v-if="documentCompanyMembers.length > 0" style="border: 1px solid #dfdfdf; border-radius: 4px; background-color: #f3f3f3">
                  <ul class="table border-bottom table-title-1">
                    <li>
                      <span>결재</span>
                      <span>성명(부서)</span>
                    </li>
                  </ul>

                  <ul id="documentCompany" class="table table-title-1">
                    <draggable class="w-full" :list="documentCompanyMembers" group="people" draggable=".item">
                      <li v-for="(member, index) in reversedDocumentCompanyMembers" :key="index" class="tbody" :class="[selectMember === member ? 'active' : '', member.move ? 'item' : 'cursor-default']" @click="onClickApprovalItem(member)">
                        <span>결재{{ approvalLine.length + documentCompanyMembers.length - index }}</span>
                        <span>{{ member.user_name }}{{ member.rank ? ` ${member.rank}` : "" }}{{ member.department ? `(${member.department})` : "" }}</span>
                      </li>
                    </draggable>
                  </ul>
                </vs-row>

                <vs-row v-else style="border: 1px solid #dfdfdf; border-radius: 4px; background-color: #f3f3f3">
                  <ul class="table border-bottom table-title-1">
                    <li>
                      <span>결재</span>
                      <span>성명(부서)</span>
                    </li>
                  </ul>
                  <ul id="documentCompany" class="table table-title-1" @click="onClickDocumentCompany">
                    <li class="tbody cursor-default">
                      <span>담당부서</span>
                      <span>{{ localDocumentCompany.label }}</span>
                    </li>
                  </ul>
                </vs-row>
              </vs-col>
            </template>

            <!-- 처리부서함이 지정되지 않았을 경우, 선택하라는 메시지를 표시한다. -->
            <vs-col v-else class="pl-4">
              <vs-row style="border: 1px solid #dfdfdf; border-radius: 4px; background-color: #f3f3f3; min-height: 80px">
                <div class="flex items-center justify-center w-full p-4">
                  <feather-icon icon="InfoIcon" class="w-5 h-5 mr-2" style="color: rgba(var(--vs-primary))" />
                  <span>처리부서가 선택되지 않았습니다.</span>
                </div>
                <div v-if="defaultDocumentCompany" class="flex items-center justify-center w-full p-4 pt-0">
                  <!--처리부서 지정 버튼 추가-->
                  <vs-button class="mr-4" color="secondary" @click="handleDocumentCompanySelect">기본 처리부서 지정</vs-button>
                </div>
              </vs-row>
            </vs-col>
          </vs-row>

          <!-- 수신참조 -->
          <vs-row class="right-body mb-4">
            <vs-col class="btn-list">
              <vs-button
                class="addbtn p-0 mb-2"
                type="border"
                @click="removeReferenceItem"
                :disabled="!selectMember.user_id && !selectReferenceCompanyInList"
                title="선택한 참조 항목 제거"
                >&lt;</vs-button
              >
              <vs-button
                class="addbtn p-0"
                type="border"
                :disabled="isDisabledReferenceAddButton"
                @click="
                  () => {
                    addMember('reference');
                  }
                "
                >&gt;</vs-button
              >
              <vs-button
                class="addbtn p-0 mt-2"
                style="max-height: 40px;height: 40px;"
                type="border"
                :disabled="!selectedVirtualCompany || isSelectedCompanyInReferenceList"
                @click="addReferenceCompany"
                title="선택한 부서 추가"
              >
              <div>
                <div style="margin-bottom: -3px;">&gt;</div>
                <div>
                  <feather-icon icon="BriefcaseIcon" class="w-4 h-4" />
                </div>
                </div>
              </vs-button>
            </vs-col>
            <vs-col class="pl-4">
              <vs-row>
                <vs-col class="mb-2">
                  <h5><i class="dot"></i>수신참조</h5>
                </vs-col>
              </vs-row>
              <vs-row style="border: 1px solid #dfdfdf; border-radius: 4px; background-color: #f3f3f3">
                <ul class="table border-bottom table-title-1">
                  <li>
                    <span>참조</span>
                    <span>성명(부서)</span>
                  </li>
                </ul>

                <ul id="reference" class="table table-title-1">
                  <!-- 수신참조 부서 먼저 표시 (드래그 불가) -->
                  <li
                    v-for="(company, index) in localReferenceCompanies"
                    :key="`company-${index}`"
                    class="tbody cursor-pointer"
                    :class="[selectReferenceCompanyInList === company ? 'active' : '']"
                    @click="onClickReferenceCompany(company)"
                  >
                    <span>참조부서</span>
                    <span>
                      {{ company.label }}
                    </span>
                  </li>

                  <!-- 수신참조 사용자 표시 (드래그 가능) -->
                  <draggable class="w-full" :list="referenceLine" group="people">
                    <li
                      v-for="(member, index) in referenceLine"
                      :key="`user-${index}`"
                      class="tbody"
                      :class="selectMember === member ? 'active' : ''"
                      @click="onClickReferenceMember(member)"
                    >
                      <span>참조{{ index + 1 }}</span>
                      <span>
                        {{ member.user_name }}{{ member.rank ? ` ${member.rank}` : "" }}{{ member.department ? `(${member.department})` : "" }}
                      </span>
                    </li>
                  </draggable>
                </ul>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-col>
    </vs-row>

    <div v-if="enabled" class="vx-row">
      <!-- Footer -->
      <div class="mt-8 px-4 w-full">
        <div class="float-right">
          <vs-button class="mr-4" color="secondary" @click="handleNext">적용</vs-button>
          <vs-button color="#EDEDED" text-color="black" type="filled" @click="handleCloseSelf">취소</vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import draggable from "vuedraggable";
import KPagination from "@/components/kPagination/kPagination";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";
import CompanyTreeView from "@/views/approval/components/CompanyTreeView.vue";

export default {
  name: "PopupApprovalProcess",
  components: {
    CompanyTreeView,
    SimpleSpinner,
    KPagination,
    draggable,
  },
  props: {
    value: Array,
    enabled: Boolean,
    showPopup: Boolean,
    size: String,
    board: Object, // 문서정보
    /** 처리부서 */
    documentCompany: {
      type: Object,
      default: null,
    },
    /** 수신참조 부서 */
    referenceCompanies: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    // 게시판 결재 옵션에서 처리부서를 쓰지 않도록 지정했는지 (tab-items.js approvalOptions.useDocumentCompany)
    useDocumentCompany() {
      return !(this.board && this.board.approvalOptions && this.board.approvalOptions.useDocumentCompany === false);
    },
    /**
     * 이 문서의 사업장 ID
     * @returns {number}
     */
    fieldId() {
      if (this.board && this.board.stdInfo) {
        return this.board.stdInfo.field_id || 0;
      }
      return 0;
    },
    /**
     * 문서에서 지정된 사업장의 기본 처리부서 ID를 반환
     */
    defaultDocumentCompany() {
      if (!this.fieldId) {
        return 0;
      }

      let foundVirtualCompany = null;
      for (const item of this.defaultDocumentCompanyInfo) {
        if (Number(item.field_id) === Number(this.fieldId)) {
          foundVirtualCompany = item.virtual_company;
          break;
        }
      }

      return foundVirtualCompany;
    },
    showPopupSync: {
      get() {
        return this.showPopup;
      },
      set() {
        this.handleCloseSelf();
      },
    },

    memberList() {
      if (this.keyword) {
        return this.visibleMembers;
      } else if (this.selectedVirtualCompany && this.$refs.companyTreeView) {
        return this.visibleVirtualCompanyMembers;
      } else {
        return [];
      }
    },

    hasVirtualCompany() {
      if (this.$store.state.auth.userInfo && this.$store.state.auth.userInfo.virtual_company_id) {
        return true;
      }
      return false;
    },

    /**
     * 현재 선택된 부서가 이미 참조부서 목록에 있는지 확인
     * @returns {boolean} 이미 목록에 있으면 true, 없으면 false
     */
    isSelectedCompanyInReferenceList() {
      if (!this.selectedVirtualCompany) {
        return false;
      }

      return this.localReferenceCompanies.some(company => company.code === this.selectedVirtualCompany.code
      );
    },

    getSelectElements() {
      const sendDataList = [];
      for (const member of this.referenceLine) {
        sendDataList.push({
          company_id: member.company_id,
          company_name: member.company_name,
          department: member.department,
          section: member.section,
          user_id: member.user_id,
          user_name: member.user_name,
          position: member.position,
          rank: member.rank,
          status_code: "wait",
          status_id: 1,
          status_name: "대기",
          type_id: 4,
          type_code: "reference",
          type_name: "참조",
        });
      }
      for (const member of this.circulationLine) {
        sendDataList.push({
          company_id: member.company_id,
          company_name: member.company_name,
          department: member.department,
          section: member.section,
          user_id: member.user_id,
          user_name: member.user_name,
          position: member.position,
          rank: member.rank,
          status_code: "wait",
          status_id: 1,
          status_name: "대기",
          type_id: 6,
          type_code: "circulation",
          type_name: "회람",
        });
      }
      for (const member of this.approvalLine) {
        sendDataList.push({
          company_id: member.company_id,
          company_name: member.company_name,
          department: member.department,
          section: member.section,
          user_id: member.user_id,
          user_name: member.user_name,
          position: member.position,
          rank: member.rank,
          status_code: "wait",
          status_id: 1,
          status_name: "대기",
          type_id: 3,
          type_code: "approval",
          type_name: "결재",
        });
      }

      return this.lineToSaveLine(sendDataList);
    },
    reversedApprovalLine() {
      return this.approvalLine.slice().reverse();
    },
    reversedDocumentCompanyMembers() {
      return this.documentCompanyMembers.slice().reverse();
    },

    localDocumentCompany: {
      get() {
        return this.documentCompany;
      },
      set(value) {
        this.$emit("update:documentCompany", value);
      },
    },
    localReferenceCompanies: {
      get() {
        return this.localReferenceCompaniesData;
      },
      set(value) {
        this.localReferenceCompaniesData = value;
        this.$emit("update:referenceCompanies", value);
      },
    },
    /**
     * "결재" 라인을 제거하는 버튼을 비활성화할지 여부를 반환한다.
     * selectMember 가 없거나, selectMember가 approvalLine 내에 없을 경우 true
     */
    isDisabledApprovalRemoveButton() {
      if (!this.selectMember || !this.selectMember.user_id || ["approve", "reject"].includes(this.selectMember.status_code)) {
        return true;
      }

      return this.indexOfMember(this.approvalLine, this.selectMember) === -1;
    },
    /**
     * "결재" 라인을 추가하는 버튼을 비활성화할지 여부를 반환한다.
     */
    isDisabledApprovalAddButton() {
      // 이미 처리부서에서 결재한 사용자가 있을 경우, 일반 결재선에 사람을 추가할 수 없다.
      if (this.isDocumentCompanyApproved || !this.selectMember || !this.selectMember.user_id) {
        return true;
      }
      // selectMember가 approvalLine 내에 있다면 true
      if (this.indexOfMember(this.approvalLine, this.selectMember) !== -1) {
        return true;
      }

      // selectMember가 다른 라인에 있다면 true
      const mergedLine = this.approvalLine.concat(this.referenceLine, this.circulationLine, this.documentCompanyMembers);
      return this.indexOfMember(mergedLine, this.selectMember) !== -1;
    },
    isDisabledReferenceRemoveButton() {
      if (!this.selectMember || !this.selectMember.user_id) {
        return true;
      }

      return this.indexOfMember(this.referenceLine, this.selectMember) === -1;
    },
    isDisabledReferenceAddButton() {
      if (!this.selectMember || !this.selectMember.user_id) {
        return true;
      }

      if (this.indexOfMember(this.referenceLine, this.selectMember) !== -1) {
        return true;
      }

      const mergedLine = this.approvalLine.concat(this.referenceLine, this.circulationLine, this.documentCompanyMembers);
      return this.indexOfMember(mergedLine, this.selectMember) !== -1;
    },
    /**
     * "처리부서" 라인을 제거하는 버튼을 비활성화할지 여부를 반환한다.
     *
     */
    isDisabledDocumentCompanyRemoveButton() {
      // 처리부서 지정되지 않았다면 true
      if (!this.localDocumentCompany || !this.localDocumentCompany.id) {
        return true;
      }

      // 처리부서 내에 사용자 목록이 비었다면 false
      if (this.documentCompanyMembers.length === 0) {
        return false;
      }

      // selectMember가 documentCompanyMembers 내에 없다면 true
      return this.indexOfMember(this.documentCompanyMembers, this.selectMember) === -1;
    },
    /**
     * "처리부서" 라인을 추가하는 버튼을 비활성화할지 여부를 반환한다.
     */
    isDisabledDocumentCompanyAddButton() {
      // 처리부서 지정되지 않았다면
      if (!this.localDocumentCompany || !this.localDocumentCompany.id) {
        // selectedVirtualCompany가 없다면 true
        if (!this.selectedVirtualCompany) {
          return true;
        }
        return false;
      } else {
        // 만약 현재 사용자가, 처리부서와 같을 경우에만 추가할 수 있다
        if (this.userInfo.virtual_company_id !== this.localDocumentCompany.virtual_company_id) {
          return true;
        }

        // selectMember가 없다면 true
        if (!this.selectMember || !this.selectMember.user_id) {
          return true;
        }

        // selectMember가 documentCompanyMembers 내에 있다면 true
        if (this.indexOfMember(this.documentCompanyMembers, this.selectMember) !== -1) {
          return true;
        }

        // selectMember가 다른 라인에 있다면 true
        const mergedLine = this.approvalLine.concat(this.referenceLine, this.circulationLine);
        return this.indexOfMember(mergedLine, this.selectMember) !== -1;
      }
    },
  },
  watch: {
    close() {},
    async showPopup(showPopup) {
      this.keyword = "";
      if (showPopup) {
        // 이전 결재선을 먼저 채워서 팝업이 열리자마자 즉시 표시한다.
        // loadMembers 완료를 기다리지 않으므로 로딩 중 "적용" 클릭으로 인한 결재선 소실을 방지한다.
        this.approvalLine = [];
        this.referenceLine = [];
        this.circulationLine = [];
        if (this.value && this.value.length > 0) {
          // 현재 결재중인 사람의 index가져오기
          const _fi = this.value.findIndex((_line) => _line.user_id === this.board.turnApprovalId);
          // 모든 사람이 승인한 경우에는 turnApprovalId 값이 없을 수 있다.

          /**
           * 처리부서 결재자 중에서 결재한 사용자가 존재하는지 여부
           * 처리부서를 변경할 수 없도록 하기 위함
           */
          let isDocumentCompanyApproved = false;

          for (let i = 0; i < this.value.length; i++) {
            const member = this.value[i];
            if (member.type_code !== "register") {
              this.selectMember = {
                document_company_id: member.document_company_id,
                document_company_code: member.document_company_code,
                company_id: member.company_id,
                company_name: member.company_name,
                department: member.department,
                section: member.section,
                type_code: member.type_code,
                type_id: member.type_id,
                type_name: member.type_name,
                user_id: member.user_id,
                user_name: member.user_name,
                position: member.position,
                rank: member.rank,
                status_code: member.status_code || "wait",
                status_id: member.status_id || 1,
                status_name: member.status_name || "대기",
                move: !(i <= _fi || ["approve", "reject"].includes(member.status_code)), // _fi 이하의 데이터는 move를 false로 설정
              };

              // 처리부서 결재자 중에서 결재한 사용자가 존재하는지 여부
              // 처리부서를 변경할 수 없도록 하기 위함
              if (member.document_company_id && member.type_code === "approval" && ["approve", "reject"].includes(member.status_code)) {
                isDocumentCompanyApproved = true;
              }

              // 만약 document_company_id가 있으면 처리부서로 추가
              if (member.document_company_id) {
                member.type_code = "documentCompany";
              }

              this.addMember(member.type_code);
            }
          }
          this.isDocumentCompanyApproved = isDocumentCompanyApproved;
        }

        // 직원 검색 목록을 비동기로 로드한다.
        await this.loadMembers("");

        // loadMembers 완료 후, 이미 결재선에 등록된 인원을 검색 목록에서 제거한다.
        // (순서 변경으로 addMember 시점에 members가 비어있어 제거되지 않았으므로 여기서 정리)
        const allLines = [
          ...this.approvalLine,
          ...this.referenceLine,
          ...this.circulationLine,
          ...this.documentCompanyMembers,
        ];
        for (let i = 0; i < allLines.length; i++) {
          const idx = this.indexOfMember(this.members, allLines[i]);
          if (idx >= 0) this.members.splice(idx, 1);
        }

        await this.loadApprovalLines();

        // props에서 referenceCompanies 초기값 가져오기
        this.localReferenceCompaniesData = Array.isArray(this.referenceCompanies) ? [...this.referenceCompanies] : [];
      } else {
        this.approvalLine = [];
        this.referenceLine = [];
        this.circulationLine = [];
      }

      // 팝업이 닫힐 때, 결재선 조직도를 초기화한다
      if (!showPopup) {
        if (this.$refs.companyTreeView) {
          this.$refs.companyTreeView.reset();
        }
        this.selectedVirtualCompany = null;
        this.selectReferenceCompany = null;
        this.keyword = "";
        this.searchType = "";
        this.companyKeyword = "";
      }
    },

    // props로 전달된 referenceCompanies가 변경될 때 로컬 데이터 업데이트
    referenceCompanies: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.localReferenceCompaniesData = [...newVal];
        } else {
          this.localReferenceCompaniesData = [];
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      active: false,

      loadingMembers: false,
      searchTimeout: null,

      companyKeyword: "", // 부서 검색어

      searchType: "", // 검색 타입
      keyword: "", // 사용자 검색어

      // 부서 트리에서 선택된 부서
      selectedVirtualCompany: null,

      // 선택한 참조부서
      selectReferenceCompany: null,

      // 선택된 참조부서 목록에서 선택된 참조부서
      selectReferenceCompanyInList: null,

      // 결재라인
      lineList: [],
      lineTitle: "",

      // API에서 불러온 전체 직원 목록
      totalMembers: [],

      // 검색어 필터링 된 직원목록
      members: [],
      // 선택된 부서에 소속된 회원 목록
      virtualCompanyMembers: [],

      // 화면에 노출할 회원 목록
      visibleMembers: [],
      // 화면에 노출할 가상회사 회원 목록
      visibleVirtualCompanyMembers: [],

      //선택된 직원
      selectMember: {},

      approvalLine: [],
      referenceLine: [],
      circulationLine: [],

      /**
       * 처리부서에 할당된 인원
       * 최종적으로, approvalLine 말단에 추가된다
       */
      documentCompanyMembers: [],

      /**
       * 기본 처리부서 정보
       * 사업장마다 기본적으로 처리하는 부서 정보가 있다
       */
      defaultDocumentCompanyInfo: [],

      /**
       * 참조 부서 목록 (로컬 데이터)
       */
      localReferenceCompaniesData: [],

      page: {
        lastPage: 1,
        current: 1,
        perPage: 5,
        keyword: "",
      },

      // 현재 처리부서 결재자 중에서 결재한 사용자가 존재하는지 여부
      // 처리부서를 변경할 수 없도록 하기 위함
      isDocumentCompanyApproved: false,
    };
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.handleCloseSelf();
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });

    // memberList 스크롤 이벤트
    this.$nextTick(() => {
      if (this.$refs.memberListContainer) {
        this.$refs.memberListContainer.addEventListener("scroll", this.handleScroll);
      }
    });

    // 기본 처리부서 정보 불러오기
    this.loadDefaultDocumentCompanyInfo();
  },
  destroyed() {
    if (this.$refs.memberListContainer) {
      this.$refs.memberListContainer.removeEventListener("scroll", this.handleScroll);
    }
  },

  methods: {
    initData() {},

    async initLine() {
      await this.loadMembers("");

      this.approvalLine = [];
      this.referenceLine = [];
      this.circulationLine = [];
    },

    indexOfMember(list, member) {
      for (let i = 0; i < list.length; i++) {
        if (Number(list[i].user_id) === Number(member.user_id) || Number(list[i].user_id) === Number(member.id)) {
          return i;
        }
      }
      return -1;
    },

    async loadApprovalLines() {
      // 팝업이 닫혀있는 동안에는 조회하지 않는다.
      // (vs-popup 은 닫혀있어도 슬롯을 렌더링하므로, k-pagination 이 mount 되며 change 이벤트를 발생시킨다)
      if (!this.showPopup) {
        return;
      }

      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.page.keyword;
      await this.$store.dispatch("approval/LOAD_LINE_TEMPLATE", {
        page,
        perPage,
        keyword,
      });
      const list = this.$store.state.approval.lineList;
      this.lineList = list;

      const info = this.$store.state.approval.lineInfo;
      this.page.current = info.current_page;
      this.page.lastPage = info.last_page;
      this.page.perPage = info.per_page;
    },

    // 회원목록 불러오기
    async loadMembers(keyword) {
      this.loadingMembers = true;

      try {
        const page = 1;
        const perPage = 10000;
        await this.$store.dispatch("member/LOAD_MEMBERS", {
          page,
          perPage,
          keyword,
          projectId: this.$route.params.proj_id,
          forApproval: true,
        });

        const list = this.$store.state.member.list;

        if (list) {
          await this.$store.dispatch("USER_INFO");
          const accessor = this.$store.state.auth.userInfo;

          // 보여지는 회원 리스트 (본인제외)
          this.totalMembers = [];
          this.members = [];

          if (list) {
            for (const member of list) {
              if (Number(accessor.id) !== Number(member.id)) {
                if (!member.company) {
                  // 업체 정보가 없으면 결재할 수 없다
                  continue;
                }
                const temp = {
                  company_id: member.company.id,
                  company_name: member.company.com_name,
                  company_number: member.company.com_number,
                  virtual_company: member.virtual_company,
                  department: member.department,
                  section: member.section,
                  user_id: member.id,
                  user_name: member.name,
                  position: member.position,
                  rank: member.rank,
                  status_code: "wait",
                  status_id: 1,
                  status_name: "대기",
                  type_code: "approval",
                  type_id: 3,
                  type_name: "결재",
                  move: true,
                };
                this.members.push(temp);
                this.totalMembers.push(temp);
              }
            }
          }
        }
      } finally {
        // members 정렬
        this.membersSort();

        this.handleSearch();

        this.loadingMembers = false;
      }
    },

    addMember(elementType) {
      const member = this.selectMember;

      // 유효성 검사
      if (!member.user_id) {
        return;
      }

      // elementType에 따른 라인 매핑
      const lineMapping = {
        approval: this.approvalLine,
        reference: this.referenceLine,
        circulation: this.circulationLine,
        documentCompany: this.documentCompanyMembers,
      };

      const targetLine = lineMapping[elementType];
      if (!targetLine) {
        console.warn(`Invalid elementType: ${elementType}`);
        return;
      }

      // 중복 체크 후 멤버 추가
      if (this.indexOfMember(targetLine, member) < 0) {
        // 타겟 라인에 멤버 추가
        targetLine.push(member);

        // members 배열에서 제거
        const index = this.indexOfMember(this.members, member);
        if (index >= 0) {
          this.members.splice(index, 1);
        }
      }

      // 선택된 직원 초기화
      this.selectMember = {};
      this.handleSearch();
    },

    removeMember(elementType) {
      // elementType에 따른 라인 매핑
      const lineMapping = {
        approval: this.approvalLine,
        reference: this.referenceLine,
        circulation: this.circulationLine,
        documentCompany: this.documentCompanyMembers,
      };

      const targetLine = lineMapping[elementType];
      if (!targetLine) {
        console.warn(`Invalid elementType: ${elementType}`);
        return;
      }

      const member = this.selectMember;
      if (!member.user_id || ["approve", "reject"].includes(member.status_code)) {
        return;
      }

      // 해당 라인에서 멤버 제거
      targetLine.splice(this.indexOfMember(targetLine, member), 1);

      // members 배열에 없는 경우에만 추가
      if (this.indexOfMember(this.members, member) < 0) {
        this.members.push(member);
      }

      // 멤버 정렬
      this.membersSort();

      // 선택된 직원 초기화
      this.selectMember = {};

      // 검색 핸들러 호출
      this.handleSearch();
    },

    addDocumentCompany() {
      // 선택된 가상회사가 없다면, 선택한 사용자 정보에서 가상회사를 가져온다
      if (!this.selectedVirtualCompany) {
        if (this.selectMember.virtual_company) {
          this.selectedVirtualCompany = {
            id: (this.selectMember.virtual_company.full_code).join("\\"),
            code: this.selectMember.virtual_company.code,
            full_label: this.selectMember.virtual_company.full_label,
            label: this.selectMember.virtual_company.com_name,
          }
        }
      }

      if (!this.selectedVirtualCompany) {
        console.log("selectedVirtualCompany is null", this.selectMember);
        return;
      }

      // 만약 처리부서 지정되지 않았다면, 지정한다
      if (!this.localDocumentCompany) {
        if (this.selectedVirtualCompany) {
          this.localDocumentCompany = this.selectedVirtualCompany;
        }
        return;
      }

      // 만약 선택된 업체가, 처리부서와 다르다면 컨펌이 필요하다.
      // 컨펌될 경우, 멤버를 전원 제거하고 교체한다.
      if (this.localDocumentCompany.code !== this.selectedVirtualCompany.code) {
        const beforeComName = this.localDocumentCompany.label;
        const afterComName = this.selectedVirtualCompany.label;

        if (this.isDocumentCompanyApproved) {
          alert("처리부서에서 결재한 사용자가 있습니다. 처리부서를 변경할 수 없습니다.");

        } else if (confirm(`처리부서를 변경하시겠습니까?\n[${beforeComName}]에서 [${afterComName}]로 변경됩니다.`)) {
          // documentCompanyMembers 내에 있는 사용자들을 members 배열로 이동
          this.documentCompanyMembers.forEach((member) => {
            this.members.push(member);
          });

          this.documentCompanyMembers = [];
          this.localDocumentCompany = this.selectedVirtualCompany;
        }
      } else {
        // 사용자를 추가한다.
        // 만약 현재 사용자가, 처리부서와 같을 경우에만 추가할 수 있다
        if (this.userInfo.virtual_company_id !== this.localDocumentCompany.virtual_company_id) {
          alert("처리부서와 다른 사용자는 추가할 수 없습니다.");
          return;
        }

        // 만약 documentCompanyMembers 배열이 비어있다면, 현재 사용자를 먼저 추가하고, 다음 사용자를 추가한다
        if (this.documentCompanyMembers.length === 0) {
          const nextMember = JSON.parse(JSON.stringify(this.selectMember));
          const me = this.$store.state.auth.userInfo;
          this.selectMember = {
            company_id: me.company_id,
            company_name: me.company_name,
            department: me.department,
            section: me.section,
            user_id: me.id,
            user_name: me.name,
            position: me.position,
            rank: me.rank,
            status_code: "wait",
            status_id: 1,
            status_name: "대기",
            type_id: 3,
            type_code: "approval",
            type_name: "결재",
            move: false,
          };
          this.addMember("documentCompany");
          this.selectMember = nextMember;
          this.addMember("documentCompany");
        } else {
          this.addMember("documentCompany");
        }
      }
    },

    handleDocumentCompanySelect() {
      if (!this.defaultDocumentCompany) {
        return;
      }

      this.selectedVirtualCompany = {
        id: this.defaultDocumentCompany.id,
        code: this.defaultDocumentCompany.code,
        full_label: this.defaultDocumentCompany.full_name,
        label: this.defaultDocumentCompany.com_name
      };

      this.handleSearch();
    },

    removeDocumentCompany() {
      // 만약 사용자가 존재한다면, 사용자를 먼저 제거한다
      if (this.documentCompanyMembers.length > 0) {
        // 만약 2개 남아있고, 첫번째 사용자가 자신일 경우, 둘 다 제거한다
        if (this.documentCompanyMembers.length === 2 && this.documentCompanyMembers[0].user_id === this.$store.state.auth.userInfo.id) {
          this.removeMember("documentCompany");
          this.documentCompanyMembers = [];
        } else {
          this.removeMember("documentCompany");
        }
        return;
      }

      // 처리부서를 해제할 것인지 컨펌받는다
      if (confirm("처리부서를 해제하시겠습니까?")) {
        this.localDocumentCompany = null;
      }
    },

    /**
     * 사이트 설정에서 기본처리부서 정보를 가져온다
     * @returns {Promise<void>}
     */
    async loadDefaultDocumentCompanyInfo() {
      try {
        const cacheKey = `${this.hostname}_기본처리부서.3`;
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          const parsed = JSON.parse(cached);
          // 캐시가 1시간(3600초) 이내면 사용
          if (new Date().getTime() - parsed.timestamp < 3600 * 1000) {
            this.defaultDocumentCompanyInfo = parsed.data;
            return;
          }
        }
        // 캐시가 없거나 만료된 경우 새로 데이터를 로드
        const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
          key: "기본처리부서",
        });
        if (config) {
          const cacheData = {
            data: config,
            timestamp: new Date().getTime(),
          };
          localStorage.setItem(cacheKey, JSON.stringify(cacheData));
          this.defaultDocumentCompanyInfo = config;
        }
      } catch (error) {
        console.error("Error loading default document company info:", error);
      }
    },


    // 전송시 부모에 데이터 전달
    /*
     *
     * */
    sendApprovalList() {
      const sendDataList = [];

      // 생성자
      if (this.postId) {
        const registerUser = this.board.approvalLine[0];
        if (registerUser) sendDataList.push(registerUser);
      }

      // console.log(this.board.approvalLine);
      // console.log(registerUser, this.approvalLine);

      for (const member of this.approvalLine) {
        if (!member.move) {
          const findData = this.board.approvalLine.find((_line) => _line.user_id === member.user_id);
          if (findData) {
            sendDataList.push(findData);
          } else {
            sendDataList.push({
              company_id: member.company_id,
              company_name: member.company_name,
              department: member.department,
              section: member.section,
              user_id: member.user_id,
              user_name: member.user_name,
              position: member.position,
              rank: member.rank,
              status_code: member.status_code || "wait",
              status_id: member.status_id || 1,
              status_name: member.status_name || "대기",
              type_id: member.type_id,
              type_code: member.type_code,
              type_name: member.type_name,
            });
          }
        } else {
          sendDataList.push({
            company_id: member.company_id,
            company_name: member.company_name,
            department: member.department,
            section: member.section,
            user_id: member.user_id,
            user_name: member.user_name,
            position: member.position,
            rank: member.rank,
            status_code: "wait",
            status_id: 1,
            status_name: "대기",
            type_id: 3,
            type_code: "approval",
            type_name: "결재",
          });
        }
      }

      // 처리부서
      if (this.localDocumentCompany && this.localDocumentCompany.id && this.documentCompanyMembers.length > 0) {
        for (const member of this.documentCompanyMembers) {
          sendDataList.push({
            document_company_id: this.localDocumentCompany.id,
            document_company_code: this.localDocumentCompany.code,
            company_id: member.company_id,
            company_name: member.company_name,
            department: member.department,
            section: member.section,
            user_id: member.user_id,
            user_name: member.user_name,
            position: member.position,
            rank: member.rank,
            status_code: member.status_code ? member.status_code : "wait",
            status_id: member.status_id ? member.status_id : 1,
            status_name: member.status_name ? member.status_name : "대기",
            type_id: 3,
            type_code: "approval",
            type_name: "결재",
          });
        }
      }


      for (const member of this.referenceLine) {
        sendDataList.push({
          company_id: member.company_id,
          company_name: member.company_name,
          department: member.department,
          section: member.section,
          user_id: member.user_id,
          user_name: member.user_name,
          position: member.position,
          rank: member.rank,
          status_code: "wait",
          status_id: 1,
          status_name: "대기",
          type_id: 4,
          type_code: "reference",
          type_name: "참조",
        });
      }

      for (const member of this.circulationLine) {
        sendDataList.push({
          company_id: member.company_id,
          company_name: member.company_name,
          department: member.department,
          section: member.section,
          user_id: member.user_id,
          user_name: member.user_name,
          position: member.position,
          rank: member.rank,
          status_code: "wait",
          status_id: 1,
          status_name: "대기",
          type_id: 6,
          type_code: "circulation",
          type_name: "회람",
        });
      }

      this.$emit("input", sendDataList, this.localDocumentCompany);
      this.$emit("sendApprovalList", sendDataList, this.localDocumentCompany, this.localReferenceCompanies);
    },

    membersSort() {
      const rankOrder = [
        "팀장",
        "부장",
        "부부장",
        "차장",
        "과장",
        "관리부장",
        "대표",
        "대표이사",
        "상무",
        "상무이사",
        "전무",
        "전무이사",
        "이사",
        "본부장",
        "소장",
        "지사장",
        "지소장",
        "기성",
        "기장",
        "계장",
        "주임(갑)",
        "주임(을)",
        "촉탁",
        "대리",
        "대리(인천공장)",
        "사원",
        "기계공",
        "기술부 직원",
        "용접공",
        "작업자",
        "선임",
        "선임연구원",
        "수석",
        "수석연구원",
        "신호수",
        "운전",
        "안전관리자",
        "안전관리팀장",
        "기사",
        "기감",
        "간호사",
        "경비대장",
        "고문",
        "공용",
        "공장장",
        "과장/현장관리",
        "부수석연구원",
        "실장",
        "특경 조원",
        "특경 조장",
        "팀장(차장)",
        "현장소장",
        "화기공",
        "점장",
        "매니저",
        "일용",
        "일용직",
        "조장",
      ];

      const sortMembers = (members) => {
        // 1. virtual_company.code 존재 여부로 배열 분리
        const withVirtualCode = [];
        const withoutVirtualCode = [];

        members.forEach((member) => {
          if (member.virtual_company && member.virtual_company.code) {
            withVirtualCode.push(member);
          } else {
            withoutVirtualCode.push(member);
          }
        });

        // 2. virtual_company.code 기준 오름차순 정렬
        withVirtualCode.sort((a, b) => {
          const fullCodeA = a.virtual_company.full_code;
          const fullCodeB = b.virtual_company.full_code;

          // 배열 길이로 먼저 비교 (짧은 것이 앞으로)
          if (fullCodeA.length !== fullCodeB.length) {
            return fullCodeA.length - fullCodeB.length;
          }

          // 길이가 같은 경우 각 요소를 순차적으로 비교
          for (let i = 0; i < fullCodeA.length; i++) {
            const compare = fullCodeA[i].localeCompare(fullCodeB[i]);
            if (compare !== 0) return compare;
          }

          return 0;
        });

        // 3-4. virtual_company.code로 그룹화하고 rank로 정렬
        const groupedByCode = {};
        withVirtualCode.forEach((member) => {
          const code = member.virtual_company.code;
          if (!groupedByCode[code]) {
            groupedByCode[code] = [];
          }
          groupedByCode[code].push(member);
        });

        // 각 그룹 내에서 rank로 정렬
        Object.keys(groupedByCode).forEach((code) => {
          groupedByCode[code].sort((a, b) => {
            const rankA = rankOrder.indexOf(a.rank);
            const rankB = rankOrder.indexOf(b.rank);
            return rankA - rankB;
          });
        });

        // 5. 그룹 배열 합치기
        let sortedWithVirtualCode = [];
        Object.values(groupedByCode).forEach((group) => {
          sortedWithVirtualCode = sortedWithVirtualCode.concat(group);
        });

        // 6-8. 같은 code와 rank를 가진 사용자끼리 그룹화하고 이름으로 정렬
        const groupedByCodeAndRank = {};
        sortedWithVirtualCode.forEach((member) => {
          const key = `${member.virtual_company.code}_${member.rank}`;
          if (!groupedByCodeAndRank[key]) {
            groupedByCodeAndRank[key] = [];
          }
          groupedByCodeAndRank[key].push(member);
        });

        Object.keys(groupedByCodeAndRank).forEach((key) => {
          groupedByCodeAndRank[key].sort((a, b) => a.user_name.localeCompare(b.user_name));
        });

        sortedWithVirtualCode = [];
        Object.values(groupedByCodeAndRank).forEach((group) => {
          sortedWithVirtualCode = sortedWithVirtualCode.concat(group);
        });

        // 9. company_name으로 정렬
        withoutVirtualCode.sort((a, b) => {
          const companyNameA = a.company_name || "";
          const companyNameB = b.company_name || "";
          const companyCompare = companyNameA.localeCompare(companyNameB);
          if (companyCompare !== 0) return companyCompare;

          const companyNumberA = a.company_number || "";
          const companyNumberB = b.company_number || "";
          return companyNumberA.localeCompare(companyNumberB);
        });

        // 10-12. company_name과 number로 그룹화하고 이름으로 정렬
        const groupedByCompany = {};
        withoutVirtualCode.forEach((member) => {
          const key = `${member.company_name}_${member.company_number}`;
          if (!groupedByCompany[key]) {
            groupedByCompany[key] = [];
          }
          groupedByCompany[key].push(member);
        });

        Object.keys(groupedByCompany).forEach((key) => {
          groupedByCompany[key].sort((a, b) => a.user_name.localeCompare(b.user_name));
        });

        let sortedWithoutVirtualCode = [];
        Object.values(groupedByCompany).forEach((group) => {
          sortedWithoutVirtualCode = sortedWithoutVirtualCode.concat(group);
        });

        // 13. 최종 배열 합치기
        return [...sortedWithVirtualCode, ...sortedWithoutVirtualCode];
      };

      // 멤버 정렬 적용
      this.members = sortMembers(this.members);
      this.totalMembers = sortMembers(this.totalMembers);
    },

    getLineElements(list) {
      const approvalList = [];

      for (const item of list) {
        if (item.element_type && item.element_type.code === "approval") {
          approvalList.push(item);
        }
      }
      return approvalList;
    },

    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSaveLine(data) {
      const approvalList = [];

      for (const member of data) {
        if (member.type_code !== "register") {
          approvalList.push({
            id: member.user_id,
            element_user: { name: member.user_name },
            element_type: { code: member.type_code },
          });
        }
      }
      return approvalList;
    },

    lineClickItem(data) {
      for (let i = 0; i < this.approvalLine.length; i++) {
        const member = this.approvalLine[i];
        this.selectMember = member;
        this.removeMember("approval");
        i = -1;
      }

      for (let i = 0; i < this.referenceLine.length; i++) {
        const member = this.referenceLine[i];
        this.selectMember = member;
        this.removeMember("reference");
        i = -1;
      }

      for (let i = 0; i < this.circulationLine.length; i++) {
        const member = this.circulationLine[i];
        this.selectMember = member;
        this.removeMember("circulation");
        i = -1;
      }

      for (const lineMember of data) {
        const user_id = lineMember.element_user_id;
        const elementType = lineMember.element_type.code;
        for (const member of this.members) {
          if (member.user_id === user_id) {
            this.selectMember = member;
            this.addMember(elementType);
          }
        }
      }
    },

    async removeLine(templateId) {
      await this.$store.dispatch("approval/DELETE_LINE_TEMPLATE", { templateId });
      await this.loadApprovalLines();
    },

    //===== [ handler ] ======

    handleCloseSelf() {
      this.$emit("closePopup", false);
      this.initData();
    },

    handleChangePage(page) {
      this.page.current = page;
      this.loadApprovalLines();
    },

    handleNext() {
      this.sendApprovalList();
      this.handleCloseSelf();
    },

    async handleSave() {
      if (this.lineTitle.trim().length <= 0) {
        alert("결재선 제목을 입력하세요");
        return;
      }

      if (this.getSelectElements.length === 0) {
        alert("아래 툴을 사용하여 결재라인을 설정하세요");
        return;
      }

      const list = [];
      for (const member of this.getSelectElements) {
        list.push({
          id: member.id,
          elementType: member.element_type.code,
        });
      }

      const title = this.lineTitle;
      const desc = "";
      const approvalLine = JSON.stringify(list);

      await this.$store.dispatch("approval/CREATE_LINE_TEMPLATE", {
        title,
        desc,
        approvalLine,
      });
      await this.loadApprovalLines();
    },

    handleCompanySelected(companyNode) {
      if (!companyNode) return;
      this.selectedVirtualCompany = companyNode;

      this.handleSearch();
    },

    /**
     * 현재 불러와 있는 회원 목록 중에서 검색한다
     */
    handleSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      let timeout = 300;
      if (!this.keyword) {
        timeout = 0;
      }

      this.searchTimeout = setTimeout(() => {
        this.virtualCompanyMembers = this.totalMembers.filter((member) => {
          // 결재선에 등록된 회원은 검색에서 제외
          if ([this.approvalLine, this.referenceLine, this.circulationLine, this.documentCompanyMembers].some((line) => line.some(({ user_id }) => `${user_id}` === `${member.user_id}`))) {
            return false;
          }

          const virtualCompany = member.virtual_company || null;

          if (this.selectedVirtualCompany) {
            if (!virtualCompany) return false;

            // 해당 부서 또는 이하 부서에 소속된 회원만 검색
            // const fullCode = virtualCompany.full_code || [];
            // if (!fullCode.includes(this.selectedVirtualCompany.code)) return false;

            // 해당 부서만 검색
            if (virtualCompany.code !== this.selectedVirtualCompany.code) return false;
          }

          return true;
        });

        this.members = this.totalMembers.filter((member) => {
          // 결재선에 등록된 회원은 검색에서 제외
          if ([this.approvalLine, this.referenceLine, this.circulationLine].some((line) => line.some(({ user_id }) => `${user_id}` === `${member.user_id}`))) {
            return false;
          }

          const companyName = member.company_name || "";
          const department = member.department || "";
          const userName = member.user_name || "";
          // const virtualCompany = member.virtual_company || null;
          //
          // if (this.selectedVirtualCompany) {
          //   if (!virtualCompany) return false;
          //
          //   // 해당 부서 또는 이하 부서에 소속된 회원만 검색
          //   // const fullCode = virtualCompany.full_code || [];
          //   // if (!fullCode.includes(this.selectedVirtualCompany.code)) return false;
          //
          //   // 해당 부서만 검색
          //   if (virtualCompany.code !== this.selectedVirtualCompany.code) return false;
          // }

          if (this.searchType === "부서") {
            if (companyName.includes(this.keyword) || department.includes(this.keyword)) return true;
          } else if (this.searchType === "이름") {
            if (userName.includes(this.keyword)) return true;
          } else if (companyName.includes(this.keyword) || department.includes(this.keyword) || userName.includes(this.keyword)) return true;

          return false;
        });

        this.visibleMembers = this.members.slice(0, 50);
        this.visibleVirtualCompanyMembers = this.virtualCompanyMembers.slice(0, 50);
      }, timeout);
    },

    // 결재리스트 click event
    onClickApprovalItem(member) {
      if (member.move) this.selectMember = member;
    },

    handleScroll(event) {
      const element = event.target;

      // 스크롤이 끝에 도달했는지 확인
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {
        this.onMemberScrollEnd(); // 마지막에 도달했을 때 실행
      }
    },

    // 스크롤 마지막에 도달하면, 50 아이템을 visibleMembers에 추가
    onMemberScrollEnd() {
      if (this.members.length > this.visibleMembers.length) {
        const start = this.visibleMembers.length;
        const end = start + 50;
        this.visibleMembers = this.visibleMembers.concat(this.members.slice(start, end));
      }
      if (this.virtualCompanyMembers.length > this.visibleVirtualCompanyMembers.length) {
        const start = this.visibleVirtualCompanyMembers.length;
        const end = start + 50;
        this.visibleVirtualCompanyMembers = this.visibleVirtualCompanyMembers.concat(this.virtualCompanyMembers.slice(start, end));
      }
    },

    getMemberTitle(member) {
      if (member.rank && member.rank !== "none") {
        return `${member.user_name} (${member.rank})`;
      } else {
        return member.user_name;
      }
    },

    /**
     * 처리부서의 상세한 결재선이 지정되지 않은 상태에서
     * 처리부서의 이름이 클릭됐을 때 도작::
     * 해당 부서가 트리에서 선택되도록 한다.
     */
    onClickDocumentCompany() {
      if (this.$refs.companyTreeView) {
        this.$refs.companyTreeView.changeNode(this.localDocumentCompany.code);
      }
    },

    /**
     * 수신참조 부서를 클릭했을 때 호출되는 메소드
     * 해당 부서를 선택하거나 선택 해제함 (토글)
     * @param {Object} company - 선택한 참조 부서 객체
     */
    onClickReferenceCompany(company) {
      // 이미 선택된 부서인 경우 선택 해제
      if (this.selectReferenceCompanyInList && this.selectReferenceCompanyInList.code === company.code) {
        this.selectReferenceCompanyInList = null;
      } else {
        // 새로운 부서 선택
        this.selectReferenceCompanyInList = company;
      }

      // 사용자 선택 초기화
      this.selectMember = {};
    },

    addReferenceCompany() {
      if (!this.selectedVirtualCompany) {
        return;
      }

      // 선택된 부서를 수신참조 부서 목록에 추가
      const newReferenceCompany = {
        id: this.selectedVirtualCompany.id,
        code: this.selectedVirtualCompany.code,
        label: this.selectedVirtualCompany.label,
        full_label: this.selectedVirtualCompany.full_label
      };

      // 이미 추가된 부서인지 확인
      const isDuplicate = this.localReferenceCompaniesData.some(company => company.code === newReferenceCompany.code);

      if (isDuplicate === false) {
        // 배열을 직접 수정
        const newArray = [...this.localReferenceCompaniesData];
        newArray.push(newReferenceCompany);

        // 배열을 새로 할당하여 반응성 트리거
        this.localReferenceCompaniesData = newArray;
        this.$emit("update:referenceCompanies", newArray);
      }
    },

    removeReferenceItem() {
      // 사용자가 선택되어 있으면 사용자 제거
      if (this.selectMember && this.selectMember.user_id) {
        this.removeMember('reference');
      } else if (this.selectReferenceCompanyInList) { // 부서가 선택되어 있으면 부서 제거
        this.removeReferenceCompany();
      }
    },

    removeReferenceCompany() {
      if (!this.selectReferenceCompanyInList) {
        return;
      }

      // 선택된 부서 인덱스 찾기
      const index = this.localReferenceCompaniesData.findIndex(company => company.code === this.selectReferenceCompanyInList.code);

      if (index !== -1) {
        // 배열에서 제거
        const newArray = [...this.localReferenceCompaniesData];
        newArray.splice(index, 1);

        // 상태 업데이트
        this.localReferenceCompaniesData = newArray;
        this.$emit("update:referenceCompanies", newArray);

        // 선택 초기화
        this.selectReferenceCompanyInList = null;
      }
    },

    /**
     * 수신참조 사용자를 클릭했을 때 호출되는 메소드
     * @param {Object} member - 선택한 참조 사용자 객체
     */
    onClickReferenceMember(member) {
      this.selectMember = member;
      // 참조부서 선택 초기화
      this.selectReferenceCompanyInList = null;
    },

    getSectionDepartment(writer) {
      const section = writer.section ? writer.section : "";
      const department = writer.department ? writer.department : "";

      if (section && department) {
        if (section === department) {
          return section;
        } else {
          return `${section} ${department}`;
        }
      } else if (section) {
        return section;
      } else if (department) {
        return department;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style lang="scss">
#popupApprovalProcess {
  &.con-vs-popup .vs-popup {
    width: 1200px;
    max-width: 90vw;
    min-width: 800px;

    .list {
      overflow-x: hidden;
      overflow-y: auto;
    }
  }

  .list-item {
    display: flex;
    align-items: center;
    cursor: pointer;

    &.active {
      background: rgba(var(--vs-primary), 0.1) !important;
      box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }
  }
}
</style>

<style scoped>
/* 테이블 스타일 */
ul.table {
  width: 100%;
}

ul.table > div > li {
  display: grid;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cdcdcd;
  grid-template-rows: minmax(52px, 100%);
}

ul.table > div > li:last-child {
  border-bottom: none;
}

ul.table > div > li.tbody {
  background-color: #fff;
  cursor: pointer;
}

ul.table li.tbody.active {
  background: rgba(var(--vs-primary), 0.05) !important;
}

ul.table > div > li.tbody > span {
  font-weight: normal !important;
}

ul.table > div > li > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #cdcdcd;
  padding: 6px;
  font-weight: 500;
}

ul.table > div > li > span:first-child {
  border-left: none;
}

ul.table.table-no-2 > div > li {
  grid-template-columns: 1fr 2fr 4fr;
}

ul.table.table-title-1 > div > li {
  grid-template-columns: 1fr 2fr;
}

ul.table > div > li > span {
  border-left: none;
}

.vs-row.border {
  border-left: none;
  border-right: none;
}

ul.table.table-no-2 > li {
  grid-template-columns: 1fr 2fr 4fr;
}

ul.table.table-title-1 > li {
  grid-template-columns: 1fr 2fr;
}

ul.table > li > span {
  border-left: none;
}

.member-list {
  flex-flow: column;
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  font-size: 14px;
}
.member-list-container {
  width: 100%;
  height: 730px;
  max-height: 100vh;
  overflow-y: auto;
}

.vs-row.right-body {
  display: grid !important;
  grid-template-columns: auto minmax(0, 100%);
}

.vs-row.right-body #approval,
.vs-row.right-body #reference,
.vs-row.right-body #circulation {
  display: flex !important;
  flex-flow: column;
  overflow-y: auto;
  height: 159px;
}

.vs-row.right-body #approval li:last-child,
.vs-row.right-body #reference li:last-child,
.vs-row.right-body #circulation li:last-child {
  border-bottom: 1px solid #cdcdcd;
}

.vs-row.right-body .btn-list {
  align-self: center;
}

.vs-row.right-body .vs-col {
}

.vs-row.right-body .addbtn {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
  padding: 0;
}

.no-drag {
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

.rotate-icon {
  animation: rotate 1s linear infinite;
}
</style>
